import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { RadioGroup } from '@uhg-abyss/web/ui/RadioGroup';

const Wrapper = styled('div', {
  '.abyss-descriptors-error-message': {
    fontSize: '13px ',
    fontWeight: '400',
  },
});
const FlexDisplay = styled('div', {
  display: 'flex',
  gap: '20px 4%',
  alignItems: 'baseline',
  flexWrap: 'wrap',

  '@screen < $sm': {
    gap: '20px 0',
  },
});

const FlexItem = styled('div', {
  flexBasis: '100%',
  '@screen < $sm': {
    flexBasis: '100%',
  },
});

export const ConnectToAPI = () => {
  return (
    <Wrapper>
      <FlexDisplay>
        <FlexItem>
          <RadioGroup
            label="Are you ready to connect to our APIs?"
            model="connectToAPI"
            display="row"
            validators={{ required: true }}
            css={{
              'abyss-radio-group-label': {
                position: 'relative',
                fontSize: '25.63px !important',
                fontWeight: '700',
                color: 'rgb(0, 38, 119)',
                padding: '8px 8px 8px 0px',
              },
            }}
          >
            <RadioGroup.Radio label="Yes" value="Yes" />
            <RadioGroup.Radio label="Not at this time" value="No" />
          </RadioGroup>
        </FlexItem>
      </FlexDisplay>
    </Wrapper>
  );
};
